import { partialExport, cancelExport } from 'store/shared/api';
import downloadFile from 'store/utils/downloadFile';
import { getProjectName } from 'store/services/project/selectors';
import promiseWithMinimunTime from 'store/utils/promiseWithMinimumTime';

import ErrorHandler from 'store/utils/ErrorHandler';
import Notify from 'store/utils/Notify';

export const partialExportAction = configuration => (filename, ids) => async (
  dispatch,
  getState,
) => {
  const { path, types, queryKey } = configuration;
  const projectName = getProjectName(getState());

  let error = null;

  dispatch({
    type: types.request,
  });

  const THREE_SEC_IN_MILLISEC = 3 * 1000;

  try {
    const partialExportWithMinTime = promiseWithMinimunTime(
      partialExport,
      THREE_SEC_IN_MILLISEC,
    );

    const { data } = await partialExportWithMinTime(path, ids, queryKey);

    await downloadFile(data, `${projectName}-${filename || path}.zip`);
  } catch (err) {
    error = err;
    Notify.error({
      title: `Fail to export ${path}`,
      description: ErrorHandler.getNotificationError(err),
    });
  }

  dispatch({
    type: types.complete,
    error,
  });
};

export const cancelPartialExportAction = configuration => () => dispatch => {
  const { path, types } = configuration;

  cancelExport(path);

  dispatch({
    type: types.cancel,
  });
};
